import { render, staticRenderFns } from "./CrmUserPicker.vue?vue&type=template&id=f52f1570&"
import script from "./CrmUserPicker.vue?vue&type=script&lang=js&"
export * from "./CrmUserPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports